var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('full-modal',{attrs:{"modal-title":_vm.title}},[_c('data-table',{attrs:{"headers":_vm.headers,"fields":_vm.fields,"items":_vm.serviceRequests,"title":"Service Requests"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68cf3062","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/property/dashboard/PropertyServiceRequests.vue
// module id = wGLq
// module chunks = 0 1